import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { BROWN, NEUTRAL, humanAvatarFill } from '../styles/brandTokens';

interface UserAvatarProps {
  name: string;
  avatarUrl?: string;
  size?: number;
  showName?: boolean;
  maxNameWidth?: number;
  bgColor?: string;
  initials?: string;
  sx?: object;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  avatarUrl,
  size = 28,
  showName = false,
  maxNameWidth = 120,
  bgColor,
  initials,
  sx
}) => {
  // People get warm sand fills (purple is reserved for Theo); an explicit bgColor keeps white initials.
  const finalBgColor = bgColor || humanAvatarFill(name);
  const textColor = bgColor ? '#FFFFFF' : BROWN.ink;
  const avatarText = initials || (name ? name[0].toUpperCase() : '?');

  const avatarContent = (
    <Avatar
      src={avatarUrl}
      sx={{
        width: size,
        height: size,
        mr: showName ? 1 : 0,
        bgcolor: finalBgColor,
        color: textColor,
        fontFamily: "var(--theo-font-sans)",
        fontSize: `${size * 0.6}px`,
        fontWeight: 600,
        boxShadow: `0 0 0 1px ${NEUTRAL.border}`,
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        },
        ...sx,
      }}
    >
      {avatarText}
    </Avatar>
  );

  if (!showName) {
    return avatarContent;
  }

  return (
    <Box sx={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "flex-start",
      gap: 1
    }}>
      {avatarContent}
      <Typography
        sx={{
          fontFamily: "var(--theo-font-sans)",
          fontSize: "14px",
          fontWeight: 400,
          color: NEUTRAL.text,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: maxNameWidth
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default UserAvatar;